import React from 'react';
import { motion } from 'framer-motion';

const STEP_INITIAL = { opacity: 0, x: -28 };
const STEP_VISIBLE = { opacity: 1, x: 0 };

const ContactStepsTimeline = ({ steps, isInView }) => {
  return (
    <div className="relative">
      {/* Vertical dotted connector */}
      <div
        aria-hidden="true"
        className="absolute left-4 sm:left-6 md:left-8 top-8 bottom-8 w-px border-l-2 border-dashed border-white/15"
      />

      <ul className="space-y-6 sm:space-y-9 md:space-y-12">
        {steps.map((step, idx) => {
          const Icon = step.icon;
          const transition = { delay: 0.15 + idx * 0.12, duration: 0.55 };
          return (
            <motion.li
              key={step.id}
              initial={STEP_INITIAL}
              animate={isInView ? STEP_VISIBLE : STEP_INITIAL}
              transition={transition}
              className="relative flex items-start gap-3 sm:gap-4 md:gap-6"
              data-testid={`contact-step-${step.id}`}
            >
              <div
                className={`relative z-10 flex-shrink-0 w-9 h-9 sm:w-12 sm:h-12 md:w-16 md:h-16 rounded-full bg-gradient-to-br ${step.gradient} shadow-2xl ${step.shadow} flex items-center justify-center`}
              >
                <Icon className="w-4 h-4 sm:w-5 sm:h-5 md:w-7 md:h-7 text-white" strokeWidth={2.2} />
              </div>
              <div className="pt-0.5 sm:pt-1 md:pt-2">
                <h3 className="text-sm sm:text-lg md:text-2xl font-bold text-white mb-0.5 md:mb-1.5 leading-tight">
                  {step.title}
                </h3>
                <p className="text-[11px] sm:text-sm md:text-base text-gray-400 max-w-xs leading-snug md:leading-relaxed">
                  {step.desc}
                </p>
              </div>
            </motion.li>
          );
        })}
      </ul>
    </div>
  );
};

export default ContactStepsTimeline;
